import TransactionIngredient from '@/models/transactionIngredient';
import TransactionProduct from '@/models/transactionProduct';
import TransactionStaff from '@/models/transactionStaff';
import TransactionStorehouse from '@/models/transactionStorehouse';
import SystemDate from '@/utils/systemDate';

export enum TransactionType {
  INSERTION = 'INSERTION',
  SHARED = 'SHARED',
  WRITE_OFF = 'WRITE_OFF',
  REQUEST = 'REQUEST'
}

export const RECEIVE_TYPES = [
  TransactionType.INSERTION,
  TransactionType.REQUEST
];

export default class Transaction {
  public id: number;
  public type: TransactionType;
  public createdAt: number;
  public contractor: string;
  public comment: string | null = null;
  public cost: number | null = null;
  public ingredients: TransactionIngredient[] = [];
  public isComplete: boolean;
  public isCancel: boolean;
  public isReceive: boolean;
  public products: TransactionProduct[] = [];
  public staffTransport: TransactionStaff | null = null;
  public staffReceive: TransactionStaff | null = null;
  public storehouseContractor: any = null;
  public storehouseTransport: TransactionStorehouse | null = null;
  public storehouseReceive: TransactionStorehouse | null = null;

  public constructor(transactionProps: any, isReceive: boolean) {
    this.id = transactionProps.id;
    this.type = transactionProps.type;
    this.createdAt = transactionProps.createdAt;
    this.contractor = transactionProps.contractor;
    this.comment = transactionProps.comment;
    this.cost = transactionProps.cost;
    this.ingredients = transactionProps.ingredients.map((transactionIngredientProps: any) => {
      return new TransactionIngredient(transactionIngredientProps);
    });
    this.isComplete = transactionProps.isComplete;
    this.isCancel = transactionProps.isCancel;
    this.isReceive = isReceive;
    this.products = transactionProps.products.map((transactionProductProps: any) => {
      return new TransactionProduct(transactionProductProps);
    });

    if (null !== transactionProps.staffTransport) {
      this.staffTransport = new TransactionStaff(transactionProps.staffTransport);
    }

    if (null !== transactionProps.staffReceive) {
      this.staffReceive = new TransactionStaff(transactionProps.staffReceive);
    }

    this.storehouseContractor = transactionProps.storehouseContractor;

    if (null !== transactionProps.storehouseTransport) {
      this.storehouseTransport = new TransactionStorehouse(transactionProps.storehouseTransport);
    }

    if (null !== transactionProps.storehouseReceive) {
      this.storehouseReceive = new TransactionStorehouse(transactionProps.storehouseReceive);
    }
  }

  public get date() {
    return new SystemDate(this.createdAt * 1000);
  }

  public get isShared(): boolean {
    return TransactionType.SHARED === this.type;
  }

  public get isWriteOff(): boolean {
    return TransactionType.WRITE_OFF === this.type;
  }

  public get isInsertion(): boolean {
    return TransactionType.INSERTION === this.type;
  }

  public get typeTranslate(): string {
    return this.isReceive ? 'Поступление' : 'Списание';
  }

  public complete() {
    this.isComplete = true;
  }
}
